import { resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_page_header = _resolveComponent("ontos-page-header")!
  const _component_ontos_class_input = _resolveComponent("ontos-class-input")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_ontos_base = _resolveComponent("ontos-base")!

  return (_openBlock(), _createBlock(_component_ontos_base, _mergeProps(_ctx.baseProps, { ref: "base" }), {
    default: _withCtx(() => [
      _createVNode(_component_v_form, { ref: "form" }, {
        default: _withCtx(() => [
          _createVNode(_component_ontos_page_header, _normalizeProps(_guardReactiveProps(_ctx.heading)), null, 16),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "8" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ontos_class_input, {
                    ref: "input",
                    value: _ctx.idea,
                    onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.idea = $event)),
                    ideas: _ctx.workspace.ideas,
                    "start-with-auto-alias": "",
                    "start-with-auto-plural": ""
                  }, null, 8, ["value", "ideas"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_checkbox, {
                    modelValue: _ctx.identifiedByName,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.identifiedByName) = $event)),
                    label: _ctx.$tt('identified-by-name')
                  }, null, 8, ["modelValue", "label"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { "align-self": "center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    size: "small",
                    color: "primary",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.save()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { start: "" }, {
                        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                          _createTextVNode("mdi-content-save", -1)
                        ]))]),
                        _: 1
                      }),
                      _createTextVNode(" " + _toDisplayString(_ctx.$tt('save')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512)
    ]),
    _: 1
  }, 16))
}